module.exports = __webpack_public_path__ + "img/b7.f5475aed.jpg";